import { E2EElement, E2EPage, newE2EPage } from "@stencil/core/testing";

describe("ux-stepper", () => {
    it("buttons increment/decrement value by step size", async () => {
        const page = await newE2EPage({
            html: `<ux-stepper step="2" value="1"></ux-stepper>`
        });

        const component = await page.find("ux-stepper");
        const incButton = await page.find(".ux-stepper__increase");
        const decButton = await page.find(".ux-stepper__decrease");

        await incButton.click();
        await page.waitForChanges();
        expect(await component.getProperty("value")).toEqual(3);

        await decButton.click();
        await page.waitForChanges();
        expect(await component.getProperty("value")).toEqual(1);
    });

    it("buttons emit uxChange", async () => {
        const page = await newE2EPage({
            html: `<ux-stepper step="2" value="1"></ux-stepper>`
        });

        const component = await page.find("ux-stepper");
        const incButton = await page.find(".ux-stepper__increase");
        const decButton = await page.find(".ux-stepper__decrease");

        const uxChange = await component.spyOnEvent("uxChange");

        await incButton.click();
        await page.waitForChanges();

        expect(uxChange).toHaveReceivedEventTimes(1);

        await decButton.click();
        await page.waitForChanges();

        expect(uxChange).toHaveReceivedEventTimes(2);
    });

    it("buttons disable when value equals or exceeds bounds", async () => {
        const page = await newE2EPage({
            html: `<ux-stepper value="5" min="1" max="10"></ux-stepper>`
        });

        const component = await page.find("ux-stepper");
        const decButton = await page.find(".ux-stepper__decrease");
        const incButton = await page.find(".ux-stepper__increase");

        expect(await decButton.getProperty("disabled")).toEqual(false);
        expect(await incButton.getProperty("disabled")).toEqual(false);

        await assertDisabled(page, component, incButton, 10);
        await assertDisabled(page, component, incButton, 100);

        await assertDisabled(page, component, decButton, 1);
        await assertDisabled(page, component, decButton, -100);

        component.setProperty("value", 2);
        await page.waitForChanges();

        expect(await decButton.getProperty("disabled")).toEqual(false);
        expect(await incButton.getProperty("disabled")).toEqual(false);
    });

    describe("Validation", () => {
        it("should set invald when calling validate method", async () => {
            const page = await newE2EPage({
                html: `<ux-stepper value="0" min="1" max="10"></ux-stepper>`
            });

            const component = await page.find("ux-stepper");
            const uxInvalid = await component.spyOnEvent("uxInvalid");

            component.callMethod("validate");

            await page.waitForChanges();

            expect(await component.getProperty("error")).toEqual(true);
            expect(uxInvalid).toHaveReceivedEvent();
        });
    });
});

async function assertDisabled(page: E2EPage, component: E2EElement, button: E2EElement, val: number) {
    component.setProperty("value", val);
    await page.waitForChanges();

    expect(await button.getProperty("disabled")).toEqual(true);
}
